// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RG-WK","top":"styles_top__37Mym"};